let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bs3J9")).then(() => parcelRequire('dN7zS'));